import React from 'react'

import { Typography, Card, Box, Divider } from '@material-ui/core/'
import Step from '@material-ui/core/Step'
import StepContent from '@material-ui/core/StepContent'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import { makeStyles, Theme } from '@material-ui/core/styles'

import useNextStepsTexts from './useNextStepsTexts'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiStepIcon-root': {
      color: theme.palette.grey[200],
      fontSize: '18px',
      marginLeft: `${theme.spacing(1)}px`,
    },
    '& .MuiTypography-subtitle1': {
      lineHeight: 0,
    },
    '& .icon0 .MuiStepIcon-root': {
      color: theme.palette.secondary.main,
      marginLeft: `${theme.spacing(1)}px`,
    },
    '& .MuiStepIcon-text': {
      fill: 'none',
    },
    '& .MuiStepConnector-lineVertical': {
      borderColor: theme.palette.grey[200],
      borderLeftWidth: '2px',
    },
    '& .MuiStepConnector-vertical': {
      padding: '0px',
    },
    '& .MuiStepContent-root': {
      borderColor: theme.palette.grey[200],
      borderLeftWidth: '2px',
      marginTop: '0px',
      paddingLeft: `18px`,
      paddingTop: `${theme.spacing(1)}px`,
    },
  },
  nextStepsTitle: {
    '& p': {
      textTransform: 'uppercase',
      fontWeight: 'bold',
      margin: 0,
      fontSize: theme.typography.body1.fontSize,
    },
  },
  nextStepsTexts: {
    '& p': {
      margin: `${theme.spacing(2)}px 0px`,
      fontSize: theme.typography.body1.fontSize,
    },
  },
}))

export default function VerticalLinearStepper() {
  const classes = useStyles()

  const { nextStepsTexts } = useNextStepsTexts()

  return (
    <Card className={classes.root} elevation={5} data-hook="next-steps-container">
      <Box py={5} px={6}>
        <Typography variant="h3" data-hook="next-steps-title">
          Próximos pasos
        </Typography>
      </Box>
      <Divider />
      <Stepper nonLinear orientation="vertical">
        {nextStepsTexts.map(({ header, text }, i, arr) => (
          <Step key={header} active className={i !== arr.length - 1 ? `icon${i}` : ''}>
            <StepLabel data-hook="next-steps-label">
              <Box
                className={classes.nextStepsTitle}
                dangerouslySetInnerHTML={{ __html: header }}
              />
            </StepLabel>
            <StepContent data-hook="next-steps-text">
              <Box className={classes.nextStepsTexts} dangerouslySetInnerHTML={{ __html: text }} />
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Card>
  )
}
